import { Checkbox } from '@mui/material'
import { NEON_BLUE_LIGHT } from '@returnmates/client-core/src/constants/colors'
import clsx from 'clsx'
import { memo, useCallback } from 'react'
import { FieldInputProps } from 'react-final-form'

import useStyles from './styles'

interface Props {
  input?: FieldInputProps<null, HTMLElement>
  checked?: boolean
  onChange: (checked: boolean) => void
  icon?: React.ReactNode
  checkedIcon?: React.ReactNode
  disabled?: boolean
  className?: string
}

const CustomCheckbox = ({
  onChange,
  checked,
  icon,
  checkedIcon,
  className = '',
  ...props
}: Props) => {
  const classes = useStyles()

  const handleChange = useCallback(() => {
    onChange(!checked)
  }, [onChange, checked])

  return (
    <Checkbox
      onChange={handleChange}
      checked={checked}
      className={clsx(className, classes.main)}
      classes={{ checked: classes.checked, root: classes.root }}
      icon={
        icon || (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="0.5" y="0.5" width="19" height="19" rx="2.5" fill="white" stroke="#CBD3E2" />
          </svg>
        )
      }
      checkedIcon={
        checkedIcon || (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="19"
              height="19"
              rx="3.5"
              fill={NEON_BLUE_LIGHT}
              stroke={NEON_BLUE_LIGHT}
            />
            <path
              d="M16.6668 5L7.50016 14.1667L3.3335 10"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )
      }
      {...props}
    />
  )
}

export default memo(CustomCheckbox)
